export default __webpack_public_path__ + "static/media/light.2c700c74.svg";